import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiCollectionsService } from '../../../../services/collections/api/api-collections.service';
import { AlertsService } from '../../../../services/alerts.service';
import { CollectionBooster } from '../../../../models/collections/collection-booster.model';
import { CollectionBoosterDrop } from '../../../../models/collections/collection-booster-drop.model';
import { CollectionCardRankType } from '../../../../enums/collections/collection-card-rank-type.enum';

@Component({
  selector: 'app-collection-booster-edit-modal',
  templateUrl: './collection-booster-edit-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class CollectionBoosterEditModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  protected readonly CollectionCardRankType = CollectionCardRankType;
  readonly cardRankTypes = (Object.entries(CollectionCardRankType).filter(([, v]) => typeof v === 'number') as [string, number][])
    .filter(([, v]) => v !== CollectionCardRankType.None);

  isLoading: boolean = false;
  boosterRankType: CollectionCardRankType = CollectionCardRankType.None;
  cardsDropCount: number = 0;
  drops: CollectionBoosterDrop[] = [];

  private callbackSaved?: () => void;

  constructor(private apiCollectionsService: ApiCollectionsService, private alertsService: AlertsService) {}

  get totalWeight(): number {
    return this.drops.reduce((sum, d) => sum + (Number(d.rarityWeight) || 0), 0);
  }

  getDropPercent(drop: CollectionBoosterDrop): number {
    return this.totalWeight > 0 ? (Number(drop.rarityWeight) || 0) * 100 / this.totalWeight : 0;
  }

  show(booster: CollectionBooster, callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.boosterRankType = booster.boosterRankType;
    this.cardsDropCount = booster.cardsDropCount;
    this.drops = this.cardRankTypes.map(([, rank]) => {
      const drop = new CollectionBoosterDrop();
      drop.cardRankType = rank;
      drop.rarityWeight = booster.drops.find(d => d.cardRankType === rank)?.rarityWeight ?? 0;
      return drop;
    });
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    this.apiCollectionsService.editCollectionBooster(this.boosterRankType, this.cardsDropCount, this.drops).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Booster updated !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error updating booster : ' + error);
      }
    );
  }
}
